<div class="footer-bar">
    <div class="footer-bar-content">

        <div class="logo-container">
            <img class="logo-image" alt="Marsh Logo" src="../../../../assets/images/marsh-logo-rgb-sky.png" />
            <div class="logo-text">
                © {{getCurrentYear()}} Marsh. All Rights Reserved. Version: 1.0.0
            </div>
        </div>

        <div class="icons-container">
            <!-- <a href="https://www.facebook.com/people/Marsh-Global/61566446300687" class="icon-link">
                <i class="fa-brands fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com/MarshGlobal" class="icon-link">
                <i class="fa-brands fa-x-twitter"></i>
            </a>
            <a href="https://www.youtube.com/user/TheMarshChannel" class="icon-link">
                <i class="fa-brands fa-linkedin-in"></i>
            </a>
            <a href="https://www.linkedin.com/company/marsh" class="icon-link">
                <i class="fa-brands fa-instagram"></i>
            </a> -->
        </div>

        <div class="text-block-container">
            <div class="text-block">
                <span class="text-block-heading">Terms of Service</span>
                <a class="text-block-link" href="https://www.marsh.com/us/privacy-policy.html">Privacy policy</a>
                <a class="text-block-link" href="https://www.marsh.com/za/terms-of-use.html">Terms of use</a>
            </div>
            <div class="text-block">
                <span class="text-block-heading">Cookies</span>
                <a class="text-block-link" href="https://www.marsh.com/za/cookie-notice.html">Cookie notice</a>
                <a class="text-block-link" href="#" onclick="Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')">Manage cookies</a>
            </div>
        </div>

    </div>
</div>